<span class="printable-span" *ngIf="hasPrintableAccess">
	<a
		id="r5-{{ printableProductName }}-slidedeck"
		*ngIf="sem_btnEnabled"
		tooltip="{{ toolTipMsg }}"
		tooltip-class="printable-tooltip"
		placement="right"
		(click)="showWidgetModal()"
	>
		<img src="../../../../../assets/images/printable-report-download.svg" />
		<span class="printable-text">Printable Report</span>
	</a>
	<a
		*ngIf="!sem_btnEnabled && toolTipMsg"
		tooltip="{{ toolTipMsg }}"
		tooltip-class="printable-tooltip"
		placement="right"
	>
		<img src="../../../../../assets/images/Printable Report Download Disabled.svg" />
		<span class="printable-text disabled-text">Printable Report</span>
	</a>
	<a *ngIf="!sem_btnEnabled && !toolTipMsg">
		<img src="../../../../../assets/images/Printable Report Download Disabled.svg" />
		<span class="printable-text disabled-text">Printable Report</span>
	</a>
</span>

<app-modal id="productsModal">
	<div class="modal-background"></div>
	<div class="modal">
		<div class="modal-body">
			<div class="printableModalHeading">Select which metrics you want to aggregate across selected campaigns:</div>
			<div class="checkboxContainer">
				<span *ngFor="let widget of slideWidgetData">
					<label
						[ngClass]="[widget, 'container', printableModalConfig[widget].isDisabled ? 'aggregation-disabled' : '']"
					>
						{{ printableModalConfig[widget].displayName }}
						<input type="checkbox" [(ngModel)]="printableModalConfig[widget].value" value="{{ widget }}" />
						<span
							[ngClass]="[
								widget,
								'checkmark',
								printableModalConfig[widget].isDisabled ? 'aggregation-disabled' : '',
								printableModalConfig[widget].value ? '' : 'unchecked'
							]"
						></span>
					</label>
				</span>
			</div>
			<button (click)="navigateToPlatform()">Next</button>
		</div>
	</div>
</app-modal>
